import { ROUTE } from "../../../routes";
import { nextStepCredStepper } from "../../../configs/utils";
import { getMandateDeepCheckStatus, loadAgreementLinkToWebView, openFailureModal, openLoaderModal, openSuccessModal, resetModal } from "./utils";
var haveNavigated = false;
export const goBack = async (action, _datastore, { navigate, setDatastore }) => {
    await setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        url: undefined,
        counter: Math.random(),
        loading: false,
    });
    await navigate(ROUTE.KYC_STEPPER, {});
};
export const contactUs = async (action, _datastore, { navigate, setDatastore }) => {
    console.warn("*** contact us action triggered ***", action);
    await resetModal({ setDatastore });
    navigate(ROUTE.CONTACT_US_CARD);
};
export const navNext = async (action, _datastore, { navigateToBase, setDatastore }) => {
    console.warn("*** navNext action triggered ***", action);
    haveNavigated = true;
    await resetModal({ setDatastore });
    const routeObj = await nextStepCredStepper();
    await navigateToBase(routeObj.routeId, routeObj.params);
};
export const successAction = async (action, _datastore, { setDatastore, network, navigateToBase }) => {
    console.warn("*** successAction action triggered ***", action);
    openLoaderModal({ setDatastore });
    const status = await getMandateDeepCheckStatus({
        network
    });
    if (status && (status?.toLowerCase() === "completed" ||
        status?.toLowerCase() === "accepted")) {
        openSuccessModal({ setDatastore });
        setTimeout(async () => {
            if (!haveNavigated) {
                resetModal({ setDatastore });
                const routeObj = await nextStepCredStepper();
                await navigateToBase(routeObj.routeId, routeObj.params);
            }
        }, 3000);
    }
    else {
        openFailureModal({ setDatastore });
    }
};
export const failureAction = async (action, _datastore, { setDatastore }) => {
    console.warn("*** failureAction action triggered ***", action);
    openFailureModal({ setDatastore });
};
export const onModalCloseAction = async (action, _datastore, { setDatastore }) => {
    console.warn("*** onModalCloseAction action triggered ***", action);
    resetModal({ setDatastore });
};
export const onLoadAction = async (action, _datastore, { setDatastore, network, navigate }) => {
    console.warn("*** onLoadAction action triggered ***", action);
    await loadAgreementLinkToWebView({
        setDatastore,
        network,
        successCb: () => {
            setTimeout(async () => {
                if (!haveNavigated) {
                    haveNavigated = true;
                    resetModal({ setDatastore });
                    const routeObj = await nextStepCredStepper();
                    await navigate(routeObj.routeId, routeObj.params);
                }
            }, 3000);
        }
    });
};
